export default __webpack_public_path__ + "static/media/send-mail-61CEF7.596d5f2c.svg";